import styled from "styled-components";
import { FlexSpan } from "../../../ui";
export const InputSliderContainer = styled(FlexSpan) `
  max-width: 25rem;
`;
export const InputSuffix = styled.span `
  display: flex;
  color: #7E6CC1;
`;
